import UpdateBlocker from "@Components/app/notifications/UpdateBlocker";
import { AppContext } from "@Context/common/general/context";
import { useCallback, useContext } from "react";
import { defineNotificationModule, INotificationResolverProps } from "../notification-service.types";
import { useNotificationCandidate } from "../use-notification-candidate";
import { useNotificationActions } from "../shared/use-notification-actions";
import { usePlatformNotificationState } from "../shared/use-platform-notification-state";

const id = "UPDATE_REQUIRED";

const UpdateRequiredNotificationResolver = ({ priority }: INotificationResolverProps) => {
  const { state } = useContext(AppContext);
  const { handleExit } = useNotificationActions();
  const { isUpdateRequired } = usePlatformNotificationState();

  const render = useCallback(() => (
    <UpdateBlocker
      open={isUpdateRequired}
      onExit={handleExit}
      isUnityEmbedded={state.device.isUnityEmbedded}
    />
  ), [handleExit, isUpdateRequired, state.device.isUnityEmbedded]);

  useNotificationCandidate({
    id,
    priority,
    isActive: isUpdateRequired,
    render,
  });

  return null;
};

export const updateRequiredNotification = defineNotificationModule({
  id,
  Resolver: UpdateRequiredNotificationResolver,
});
